import { ActionReducerMap } from "@ngrx/store";
import { ModuleState } from "../state";
import { filtersReducer, selectedFilterReducer } from "./filter.reducer";
import { detailsReducer, maestrosReducer, materialesSimilaresReducer, unidadMedidaReducer } from "./material.reducer";
import { resultsCountReducer, stockReducer } from "./stock.reducer";
import { uiReducer } from './ui.reducer';

export const reducerMap: ActionReducerMap<ModuleState> = {
  selectedFilters: selectedFilterReducer,
  filters: filtersReducer,
  maestros: maestrosReducer,
  stock: stockReducer,
  details: detailsReducer,
  materialesSimilares: materialesSimilaresReducer,
  unidadMedida: unidadMedidaReducer,
  ui: uiReducer,
  resultsCount: resultsCountReducer
}
